import React from 'react'
import ELearningCourseDetail from '../../../modules/ELearning/Course/Detail'

const ELearningCourseDetailPage = () => {
  return <ELearningCourseDetail />
}

export default ELearningCourseDetailPage
